import { useEffect, useState } from "react";
import CenteredModal from "./DeploymentPckDetailsLoader";
import DroppedJobCard from "./DroppedJobCard";
import { useMetaDataDeployment } from "./useMetaDataDeploymentHook";
import React from "react";
import { Card } from "react-bootstrap";
import { FaDatabase } from "react-icons/fa";
import ConfirmDialog from "./Confirmation";
import ModalPopup from "../DataLineage/InfoModal";
import { getScopeCustomerId, getScopeEnvironmentId } from "../../services/activeScope";

const DropZoneCard: React.FC<any> = ({ index, job, handleJobDrop, name, type,disabled, setShowProgress, setJobsToShowProgressFor, alreadyRunning, setJobs, selectedTargets, selectedTargetsV2, env,initialJobList, tableNames, views, targetEnvironmentId}) => {
  

    const [showModalLoader, setShowModalLoader] = useState(false);
    const [packageId, setPackageId] = useState<string | null | number>(null);
    const [droppedJobs, setDroppedJobs] = useState(null);
    const [showConfirm, setShowConfirm] = useState(false);
    const [confirmStatus, setConfirmStatus] = useState(false);
    const [depPkgStatus, setdepPkgStatus] = useState(false);

    const [notAuthorized, setNotAuthorized] = useState<boolean | null>(null)
  
    const {filterListByHierarchy,
      extractJobIdsHierarchy, 
      saveJobData, 
      createDeploymentPkg, 
      // targetEnvironmentId,
      createDeploymentPkgInfo,
      transformListToBackendSchema
    } = useMetaDataDeployment();

    const onConfirm = () => {
      setShowConfirm(false);
      setConfirmStatus(true);
      setShowModalLoader(true);
    };
  
    const onCancel = () => {
      setShowConfirm(false);
      setConfirmStatus(false);
    };

    useEffect(() => {
      if (!confirmStatus) return;
    
      (async () => {
        // 1) Create the pkg, and bail out on error
        let id: number;
        try {
          id = await createDeploymentPkg({
            deployment_transaction_id: "txn_1234567890",
            deployment_pkg_name: "Dp1",
            src_environment_id: parseInt(getScopeEnvironmentId()!),
            tgt_environment_id:
              selectedTargetsV2 === env.environment_type && env.environment_id,
            is_rollbacked: false,
            rolledback_at: null,
            user_id: parseInt(localStorage.getItem("user_id")!),
            customer_id: parseInt(getScopeCustomerId()!),
            created_at: new Date("2024-01-10T10:00:00Z"),
            deployed_at: new Date("2024-01-12T11:00:00Z"),
            status: "initialized",
          });
          if (id){
            setPackageId(id);
            setdepPkgStatus(true);
          }
        } catch (error) {
          console.error("Error creating deployment package:", error);
          setdepPkgStatus(false);
          setShowModalLoader(false);
          setConfirmStatus(false)
          if(String(error).includes("Not authorized to deploy")){
            setNotAuthorized(true)
          }
          // Early return here prevents everything below from running
          return;
        }
        
        // 2) If we get here, pkg creation succeeded, now do the rest:
    
        handleJobDrop(index, droppedJobs, id);
    
        const updatedFlattenedJobDataArray = droppedJobs.map((item: any) => ({
          ...item,
          packageId: id,
        }));
    
        if (!disabled && !alreadyRunning) {
          saveJobData(name, updatedFlattenedJobDataArray, id);
        }
    
        if (droppedJobs?.length > 0 || !alreadyRunning) {
          try {
            const requestData = extractJobIdsHierarchy(droppedJobs);
            console.log(":>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>???????????????????????", initialJobList)
            const filteredMainList = filterListByHierarchy(
              initialJobList,
              requestData
            );

            const backendRequestObject = transformListToBackendSchema(
              filteredMainList,
              id,
              tableNames,
              views
            );
            await createDeploymentPkgInfo(backendRequestObject, targetEnvironmentId);
          } catch (error) {
            console.error("Error during deployment process:", error);
          } finally {
            setShowModalLoader(false);
          }
        }
      })();
    }, [confirmStatus]);
  
    return(
      <>
      { !showModalLoader ?
    <div
      className={`drop-zone ${disabled ? 'disabled' : ''}`}
      style={{
        pointerEvents: disabled ? 'none' : 'auto',
        opacity: disabled ? 0.5 : 1,
      }}
      onDrop={(e) => {
        e.preventDefault();
        if (job) {
          return;
        }
  
        const droppedJobs = JSON.parse(e.dataTransfer.getData('application/json'));
        setDroppedJobs(droppedJobs)
        setShowConfirm(true)
      }}
      onDragOver={(e) => e.preventDefault()}
    >
      {job && confirmStatus && depPkgStatus? (
        <DroppedJobCard job={job} packageId={packageId} setShowProgress={setShowProgress} setJobsToShowProgressFor={setJobsToShowProgressFor} setJobs={setJobs} selectedTargets={selectedTargets} env={name} setdepPkgStatus={setdepPkgStatus}/>
      ) :  (
        <Card className="drop-zone__placeholder-card">
          <Card.Body>
            <span className="drop-zone__icon">
              <FaDatabase />
            </span>
            <Card.Title className="drop-zone__title">
              <div>
                {name}
              </div>
              <div>
                {type}
              </div>
              </Card.Title>
            <Card.Text className="drop-zone__text">drag and drop a Package for Deployment.</Card.Text>
          </Card.Body>
        </Card>
      )}
    </div>
    :
        <CenteredModal
          show={showModalLoader}
          message="Please Wait..., Processing Request"
        />
    }
      <ConfirmDialog
        show={showConfirm}
        title="Deployment Initiation Prompt"
        message={`Are you sure you want to start the Deployment Process ?`}
        confirmText="Yes, Proceed"
        cancelText="No, Go Back"
        onConfirm={onConfirm}
        onCancel={onCancel}
      />

    <ModalPopup
      show={notAuthorized}
      onHide={()=>{
        setNotAuthorized(false)
      }}
      bodyHead="Info Message"
      bodyTitle={notAuthorized && "Deployment Failed for the Package, User is Not Authorized to proceed with this Action" }
    />
    </>
    )
};


export default DropZoneCard
